import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-members',
  templateUrl: './tutorial-members.component.html',
  styleUrls: ['./tutorial-members.component.css']
})
export class TutorialMembersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}